import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {LanguageHelper} from './LanguageHelper';

@Injectable()
export class RouterService implements IRouterService {

    constructor(public router: Router, public languageHelper: LanguageHelper) {
    }

    async redirect(url): Promise<void> {
        await this.router.navigate([url]);
        window.location.reload();
        window.scrollTo(0, 0);
    }
}

export interface IRouterService {
    redirect(url: string): Promise<void>;
}
